import { useEffect, useState } from 'react';
export default function useOrderFolderContentsFilters(folderId) {
    const [queryFilters, setQueryFilters] = useState({
        search: '',
        tags: [],
        orderName: '',
        orderBy: '',
        othersOrderBy: '',
        isActive: true,
        state: ['PRODUCTION'],
    });
    useEffect(() => {
        setQueryFilters({
            search: '',
            tags: [],
            orderName: '',
            orderBy: '',
            othersOrderBy: '',
            isActive: true,
            state: ['PRODUCTION'],
        });
    }, [folderId]);
    const handleNameChange = (name) => {
        setQueryFilters((_queryFilters) => (Object.assign(Object.assign({}, _queryFilters), { search: name })));
    };
    const handleOptionsChange = (option, order, orderName) => {
        let orderBy;
        let othersOrderBy;
        if (option !== '') {
            orderBy = `${order === 'asc' ? '' : '-'}${option}`;
            othersOrderBy = `${order === 'asc' ? '' : '-'}modelSpecification.${option}`;
        }
        else {
            orderBy = '';
            othersOrderBy = '';
        }
        setQueryFilters((_queryFilters) => (Object.assign(Object.assign({}, _queryFilters), { orderName,
            orderBy,
            othersOrderBy })));
    };
    return {
        filters: queryFilters,
        handleNameChange: handleNameChange,
        handleOptionsChange: handleOptionsChange,
    };
}
